window.apisExactExportVatCodesDetailFormatter = function(value, row) {
    let html = '';
    let data = JSON.parse(row.data);
    if (data != null && Object.keys(data).length > 0) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.data+"</textarea>";
        html += '</div>';
        html += '<div class="mt-3"></div>';
        html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
        html += '<thead>';
        html += '<tr>';
        html += '<th>'+__('Code')+'</th>';
        html += '<th>'+__('Description')+'</th>';
        html += '<th>'+__('Factor')+'</th>';
        html += '<th>'+__('Type')+'</th>';
        html += '<th>'+__('Transaction Type')+'</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        data.sort((a, b) => a.Code.localeCompare(b.Code));
        for (let i = 0; i < data.length; i++) {
            let vatCode = data[i];
            html += '<tr>';
            html += '<td>'+vatCode.Code+'</td>';
            html += '<td>'+vatCode.Description+'</td>';
            html += '<td>'+vatCode.Percentage+'</td>';
            html += '<td>'+vatCode.Type+'</td>';
            html += '<td>'+vatCode.VATTransactionType+'</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
    }
    return html;
};

